export const numberFormat = (value) =>
    new Intl.NumberFormat('en-CA', {
        style: 'currency',
        currency: 'CAD'
    }).format(value);

export const numberPerCentageFormat = (value) =>
    new Intl.NumberFormat({
        floatValue: value | undefined,
        formattedValue: value,
        value: value
    }).format(value ? value.toFixed(2) : 0.00);

export const numberDecimalFormat = (value) =>
    new Intl.NumberFormat('en-CA', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(value);

export const numberShortFormat = (value) => {
    const n = Number(value);
    if (isNaN(n)) return '$0.00';
    if (n >= 1000000) {
        return '$' + (n / 1000000).toFixed(2) + 'M';
    } else if (n >= 1000) {
        return '$' + (n / 1000).toFixed(2) + 'K';
    }
    return '$' + n.toFixed(2);
};
// export interface NumberFormatValues {
// floatValue: number | undefined;
// formattedValue: string;
// value: string;
// }
